import {
  TransactionDto,
  WalletDirectionTypeId,
  WalletTransaction,
} from 'api/Transaction/Types/Transaction'

interface NormalizedTransactionDto extends TransactionDto {
  walletCreditTransactions: WalletTransaction[]
  walletDebitTransactions: WalletTransaction[]
}

export const normalizeTransactions = (
  transactionDtos: TransactionDto[]
): NormalizedTransactionDto[] => {
  return (
    transactionDtos?.map((transactionDto) => {
      const walletCreditTransactions =
        transactionDto?.walletTransactions?.filter((x) => {
          return x.directionType.id === WalletDirectionTypeId.CREDIT
        }) || []

      const walletDebitTransactions =
        transactionDto?.walletTransactions?.filter((x) => {
          return x.directionType.id === WalletDirectionTypeId.DEBIT
        }) || []

      return {
        ...transactionDto,
        walletCreditTransactions,
        walletDebitTransactions,
      }
    }) || []
  )
}
